"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGEventHandler = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const bindings_1 = require("../../bindings");
const draw_state_1 = require("../../draw.state");
const util_draw_svg_1 = require("../../drawable/util.draw.svg");
const svg_event_translation_1 = require("./svg.event.translation");
const svg_move_1 = require("./svg.move");
const MAX_CLICK_MOVEMENT = 15;
class SVGEventHandler {
    constructor(dc, onStartHOASession) {
        this.onStartHOASession = onStartHOASession;
        this.lastRenderOptions = null;
        this.dc = dc;
    }
    static getStructure(evt) {
        const output = {
            id: null,
            label: null,
            tag: null,
            draggable: false,
            point: null,
            $event: null,
        };
        if (evt.target == null) {
            return output;
        }
        let current = evt.target;
        let count = 0;
        while (current.parentNode != null) {
            const nodeId = current.getAttribute('c-Draw-node-id');
            if (output.id == null && nodeId != null) {
                output.id = nodeId;
                output.tag = current.getAttribute('c-Draw-tag');
            }
            const labelId = current.getAttribute('c-Draw-Label');
            if (labelId != null && output.label == null) {
                output.label = labelId;
                if (current.getAttribute('c-Draw-draggable') === 'true' ||
                    current.getAttribute('c-Draw-draggable') === true) {
                    output.draggable = true;
                }
            }
            // Label will be present before the node-id
            if (output.id && (output.label || count > 0)) {
                return output;
            }
            current = current.parentNode;
            count++;
        }
        return output;
    }
    click($event) {
        var _a, _b, _c, _d, _e;
        const dc = this.dc;
        const state = dc.state;
        const clickX = state.mouseDownX;
        const clickY = state.mouseDownY;
        if (clickX != null) {
            const diffXY = Math.abs(clickX - $event.clientX) + Math.abs(clickY - $event.clientY);
            if (diffXY > MAX_CLICK_MOVEMENT) {
                return;
            }
        }
        const ctx = SVGEventHandler.getStructure($event);
        const drawableId = ctx.label === util_draw_svg_1.IkeDrawLabel.LABEL && ctx.id ? ctx.id : undefined;
        const center = svg_event_translation_1.SVGEventTranslation.translateEvent($event);
        const tool = state.tool;
        if (this.dc.state.linkFieldIds.length > 0) {
            (_a = this.onStartHOASession) === null || _a === void 0 ? void 0 : _a.call(this);
            bindings_1.IkeDrawBindings.Measurement.Marker.create(dc, { drawableId, center, $event });
            if (dc.state.autoArrangeAnnotations && this.lastRenderOptions) {
                dc.state.arrangeAnnotations(this.lastRenderOptions);
            }
            return;
        }
        if (ctx.label === util_draw_svg_1.IkeDrawLabel.DELETE) {
            (_b = this.onStartHOASession) === null || _b === void 0 ? void 0 : _b.call(this);
            bindings_1.IkeDrawBindings.Measurement.delete(dc, { drawableId: ctx.id, $event });
            return;
        }
        if (ctx.label === util_draw_svg_1.IkeDrawLabel.ACCEPT) {
            (_c = this.onStartHOASession) === null || _c === void 0 ? void 0 : _c.call(this);
            bindings_1.IkeDrawBindings.Measurement.accept(dc, { drawableId: ctx.id, $event });
            dc.state.setAutoArrangeAnnotations(dc.drawState.hasOnlyInsightDetections());
            return;
        }
        if (tool === draw_state_1.IkeDrawTool.BASE || tool === draw_state_1.IkeDrawTool.MARKER) {
            // Note that the UI currently forces the tool to be BASE until a base exists,
            // which means if the tool is MARKER, then a base must already be set.
            const highlightedId = state.hoverId;
            // If clicking on an approvable insight drawable, then approve it.
            if (highlightedId && highlightedId !== 'image') {
                if (!dc.drawState.hasDrawable(highlightedId)) {
                    return;
                }
                const drawable = dc.drawState.getDrawable(highlightedId);
                if (drawable.isApprovableInsightDrawable() && drawable.isInsightBaseOffsetDetectionClass) {
                    (_d = this.onStartHOASession) === null || _d === void 0 ? void 0 : _d.call(this);
                    drawable.approveInsightFlag();
                }
            }
            else {
                // User is clicking on empty space, so create a new base or marker.
                (_e = this.onStartHOASession) === null || _e === void 0 ? void 0 : _e.call(this);
                bindings_1.IkeDrawBindings.Measurement.Marker.create(dc, { drawableId, center, $event });
                if (dc.state.autoArrangeAnnotations && this.lastRenderOptions) {
                    dc.state.arrangeAnnotations(this.lastRenderOptions);
                }
            }
            return;
        }
        if (tool === draw_state_1.IkeDrawTool.LINE) {
            bindings_1.IkeDrawBindings.Measurement.Line.create(dc, { drawableId, center, $event });
            if (dc.state.autoArrangeAnnotations && this.lastRenderOptions) {
                dc.state.arrangeAnnotations(this.lastRenderOptions);
            }
            dc.state.toggleTool(draw_state_1.IkeDrawTool.LINE);
            return;
        }
    }
    doubleclick($event) {
        const ctx = SVGEventHandler.getStructure($event);
        if (ctx.id == null || ctx.label !== util_draw_svg_1.IkeDrawLabel.LABEL) {
            return;
        }
        const dc = this.dc;
        const state = dc.state;
        state.propertiesShow(ctx.id);
    }
    mousedown(evt) {
        const ctx = SVGEventHandler.getStructure(evt);
        const dc = this.dc;
        const state = dc.state;
        state.mouseDownX = evt.clientX;
        state.mouseDownY = evt.clientY;
        if (ctx.id && evt.which === 1 && ctx.tag !== 'image') {
            const object = dc.drawState.getDrawable(ctx.id);
            if (object == null) {
                return;
            }
            if (ctx.label == null) {
                dc.state.setSelected(null, null);
            }
            else {
                // If the base tool is selected, then we don't want to be able to select any other drawable
                if (state.tool !== draw_state_1.IkeDrawTool.BASE) {
                    dc.state.setSelected(ctx.id, ctx.label);
                }
                else {
                    const drawable = dc.drawState.getDrawable(ctx.id);
                    if (drawable.isApprovableInsightDrawable() && drawable.isInsightBaseOffsetDetectionClass) {
                        dc.state.setSelected(ctx.id, ctx.label);
                    }
                }
            }
        }
        else {
            dc.state.setSelected(null, null);
        }
        if (ctx.id == null || ctx.draggable !== true) {
            return;
        }
        ctx.$event = evt;
        // Start listening for move events.
        const mover = svg_move_1.SVGMove.create(this.dc, ctx);
        if (mover == null) {
            return;
        }
        state.moveId = ctx.id;
        mover.onMove = () => {
            bindings_1.IkeDrawBindings.Selection.move(dc, {
                label: ctx.label,
                delta: mover.delta,
                $event: null,
            });
            if (ctx.label === util_draw_svg_1.IkeDrawLabel.LABEL) {
                dc.state.setAutoArrangeAnnotations(false);
            }
        };
        mover.onStart = () => {
            var _a;
            (_a = this.onStartHOASession) === null || _a === void 0 ? void 0 : _a.call(this);
        };
        mover.start();
        mover.onEnd = () => {
            if (dc.state.autoArrangeAnnotations && ctx.label !== util_draw_svg_1.IkeDrawLabel.LABEL && this.lastRenderOptions) {
                dc.state.arrangeAnnotations(this.lastRenderOptions);
            }
        };
    }
    mousemove(evt) {
        const ctx = SVGEventHandler.getStructure(evt);
        const state = this.dc.state;
        if (ctx.id == null) {
            state.setHovered(null);
            return;
        }
        // If the base tool is selected, then we don't want to be able to select any other drawable
        if (state.tool === draw_state_1.IkeDrawTool.BASE) {
            const drawable = this.dc.drawState.getDrawable(ctx.id);
            if (drawable.isApprovableInsightDrawable() && !drawable.isInsightBaseOffsetDetectionClass) {
                state.setHovered(null);
                return;
            }
        }
        const highlightedId = state.hoverId;
        const currentMove = state.moveId;
        if (currentMove != null) {
            return;
        }
        if ((highlightedId == null && ctx.id == null) || (highlightedId && ctx.id === highlightedId)) {
            // Not moving and the highlighted ID is the same
            return;
        }
        state.setHovered(ctx.id);
    }
    mousewheel(delta, $event) {
        const dc = this.dc;
        bindings_1.IkeDrawBindings.Image.zoom(dc, {
            delta,
            center: svg_event_translation_1.SVGEventTranslation.translateEvent($event),
            $event,
        });
    }
}
exports.SVGEventHandler = SVGEventHandler;
tslib_1.__decorate([
    mobx_1.action.bound
], SVGEventHandler.prototype, "click", null);
tslib_1.__decorate([
    mobx_1.action.bound
], SVGEventHandler.prototype, "doubleclick", null);
tslib_1.__decorate([
    mobx_1.action.bound
], SVGEventHandler.prototype, "mousedown", null);
tslib_1.__decorate([
    mobx_1.action.bound
], SVGEventHandler.prototype, "mousemove", null);
tslib_1.__decorate([
    mobx_1.action.bound
], SVGEventHandler.prototype, "mousewheel", null);
//# sourceMappingURL=svg.event.js.map